import { useTranslation } from 'react-i18next'
import { BlogIcon } from 'src/components/navbar/icons/blog.icon'
import { HelpIcon } from 'src/components/navbar/icons/help.icon'
import { MessageCircleIcon } from 'src/components/navbar/icons/message-circle.icon'

export interface HelpConfigItem {
  id: string
  label: string
  path: string
  Icon: (props: any) => JSX.Element
  isExternal: boolean
}

export function HelpItemsConfig() {
  const { t } = useTranslation('components/nav')

  const notLoggedHelpItems: HelpConfigItem[] = [
    {
      id: 'faq',
      label: t('components/nav:FAQ'),
      path: 'https://lps.housi.com/faq/',
      Icon: HelpIcon,
      isExternal: true,
    },
  ]

  const loggedHelpItems: HelpConfigItem[] = [
    {
      id: 'faq',
      label: t('components/nav:FAQ'),
      path: 'https://lps.housi.com/faq/',
      Icon: HelpIcon,
      isExternal: true,
    },
    {
      id: 'blog-housi',
      label: t('components/nav:RESIDENTS-PERSONA.blog-housi'),
      path: '/blog',
      Icon: BlogIcon,
      isExternal: true,
    },
    {
      id: 'envie-feedback',
      label: t('components/nav:FEEDBACK'),
      path: 'https://api.whatsapp.com/send?1=pt_BR&phone=5511916678278',
      Icon: MessageCircleIcon,
      isExternal: true,
    },
  ]

  return {
    notLoggedHelpItems,
    loggedHelpItems,
  }
}
